import { createWithEqualityFn } from "zustand/traditional";
import { actions } from "./actions";
import { devtools } from "zustand/middleware";
import { modules } from '../../constants';

export const initialPDFState = {
    [modules.proficiencyMetrics.transactions]: {},
    [modules.proficiencyMetrics.offices]: {},
    [modules.proficiencyMetrics.agents]: {},
    [modules.proficiencyMetrics.savedAgents]: {},
    [modules.proficiencyMetrics.agentMovement]: {},
    [modules.proficiencyMetrics.suggestedAgents]: {},
    [modules.agentProduction.agentProduction]: {},
    [modules.marketShare.totals]: {},
    [modules.marketShare.coverage]: {},
    [modules.marketDynamics.marketDynamics]: {},
    downloadModalStatus: {
        isOpen: false,
        isPDFLoading: false,
        fileType: 'csv',
        fileName: null,
        clickAction: null,
    },
    agentProfileTabIndex: 0,
    agentProfileExportDetails: {},
    agentProfileTimePeriod: '',
    areasData: [],
    productionSummary: null,
    agentProfileProductionTableData: [],
    agentProfileInventoryTableData: [],
    logoSrc: undefined,
};

export const pdfStore = (set, get) => ({
    ...initialPDFState,
    ...actions(set, get),
});

export const usePDFStore = createWithEqualityFn(
    devtools(
            pdfStore,
            {
                name: 'pdf_state',
            }
    )
);
